<template>
    <div class="pokemon-level-badge">
        <v-avatar
            size="60"
            class="pokemon-level-badge__level black--text"
            :class="{'pokemon-level-badge__level--mirrored': rightHanded}"
        >
            <span class="text-h5 font-weight-black text-grey-darken-3" style="color: #000000;">{{ level }}</span>
            <v-icon size="64" class="pokemon-level-badge__star">mdi-star</v-icon>
        </v-avatar>
        <div
            v-if="freeExp !== null && freeExp !== undefined"
            class="pokemon-level-badge__exp"
            :class="{'pokemon-level-badge__exp--mirrored': rightHanded}"
            :title="expTitle"
        >{{ freeExp }} {{ $t('pokemon.pokemonManager.freeExpLabel') }}</div>
    </div>
</template>

<script>
    import {flags} from '@/config/featureFlags';

    export default {
        name: 'PokemonLevelBadge',
        props: {
            level: {type: [Number, String], required: true},
            freeExp: {type: [Number, String], default: null},
            // Volitelny native title na exp pilulce (fallback za puvodni
            // statsExpTooltip u odstraneneho Lvl/Exp tabulkoveho radku, viz
            // PokemonManager.vue) - default null = zadny title, PokemonDetail.vue
            // ho nepredava a chovani se pro ni nemeni.
            expTitle: {type: String, default: null},
        },
        computed: {
            rightHanded() {
                return flags.rightHanded;
            },
        },
    }
</script>

<style scoped>
.pokemon-level-badge__level {
    position: absolute;
    right: var(--plb-level-inset, 11px);
    bottom: var(--plb-level-bottom, 16px);
    z-index: 10;
    box-shadow: 2px 5px 12px rgb(243, 224, 184);
    background: radial-gradient(circle at 30% 30%, #ffffff, #494949);
    /* Skala JEN bubliny - exp pilulka (.pokemon-level-badge__exp) zustava
       nezavisla, aby se text zmensenim karty (PokemonDetail.vue) nezmensoval
       spolu s ni a byl citelny stejne jako v PokemonManager.vue. */
    zoom: var(--plb-level-scale, 1);
}
.pokemon-level-badge__level--mirrored {
    right: auto;
    left: var(--plb-level-inset, 11px);
}
/* !important nutne - Vuetify .v-icon ma vlastni position/color (relative,
   rgba(0,0,0,.54)) se stejnou/vyssi specificitou, bez !important hvezdicka
   prebije cislo a vykresli se tmava/plna misto bledeho podkladu za cislem. */
.pokemon-level-badge__star {
    z-index: -1 !important;
    color: #ffebbc !important;
    position: absolute !important;
    top: -3px !important;
}
.pokemon-level-badge__exp {
    position: absolute;
    left: var(--plb-exp-inset, 11px);
    bottom: var(--plb-exp-bottom, 20px);
    z-index: 10;
    background: #fff8e6;
    border: 1px solid #d9a441;
    color: #8a5a00;
    font-size: 13px;
    font-weight: 600;
    /* Explicitni line-height nutny - pilulka zije v ruznych Vuetify
       kontextech (v-card-actions v PokemonManager vs. v-card-title v
       PokemonDetail) s ruznym zdedenym line-height, bez tohohle mela v
       kazdem hostu jinou vysku (30px vs. 42px). */
    line-height: 1.4;
    padding: 4px 9px;
    border-radius: 11px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .15);
    white-space: nowrap;
}
.pokemon-level-badge__exp--mirrored {
    left: auto;
    right: var(--plb-exp-inset, 11px);
}
</style>
